import { useState } from 'react';
import { useRouter } from 'next/router';
import css from './index.module.scss';
import { submitForm } from './service';
import { useLang } from '@/i18n';
import { useGlobal } from '@/utils/useGlobal';

export default function DialogForm({ dataObj, callback }: any) {
    const { gtm } = useGlobal();
    const { t } = useLang('dp3.crowdfunding.bundle.dialog');
    const { locale } = useRouter();
    const [name, setName] = useState('');
    const [suffix, setSuffix] = useState(t('ontyu'));
    const [email, setEmail] = useState('');
    const [msg, setMsg] = useState('');
    const [selectOpen, setSelectOpen] = useState(false);

    const suffixLists = [
        { label: t('ontyu'), value: 'GROUP' },
        { label: t('sama'), value: 'PERSON' },
    ];
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

    const handleNameChange = (e: any) => {
        const value = e.target.value.trim();
        if (value.length <= 20) {
            setName(e.target.value.trim());
        }
    };

    const handleNameFocus = () => {
        if (msg === t('name_empty')) {
            setMsg('');
        }
    };

    const handleEmailChange = (e: any) => {
        const value = e.target.value.trim();
        if (value.length <= 30) {
            setEmail(e.target.value.trim());
        }
    };

    const handleEmailFocus = () => {
        if (msg === t('email_invalid')) {
            setMsg('');
        }
    };

    const handleCloseSelection = (e: any) => {
        const { className } = e?.target;
        if (!['submit', 'close', 'suffix'].includes(className) && selectOpen) {
            setSelectOpen(false);
        }
    };

    const handleSubmit = async () => {
        if (!name) {
            return setMsg(t('name_empty'));
        }
        if (!emailRegex.test(email)) {
            return setMsg(t('email_invalid'));
        }
        const obj = {
            discountLevel: 0,
            compareAtProductId: dataObj?.productId,
            compareAtVariantId: dataObj?.variantId,
            compareAtPrice: dataObj?.originalPrice,
            productId: dataObj?.productId,
            variantId: dataObj?.variantId,
            quantity: 1,
            title: dataObj?.title,
            price: dataObj?.discountPrice,
        };
        const personType = suffixLists?.find((list: any) => list.label === suffix)?.value;
        const data = {
            email,
            name,
            personType,
            purchaseUrl: dataObj?.link_buy,
            productItems: [obj],
        };
        const res = await submitForm(data, locale);
        // return callback('quotation', defaultObj);
        if (res?.code === '0') {
            if (res?.data?.seqNumber && res?.data?.quoteId) {
                callback('quotation', { ...res?.data, personType: suffix });
            }
            try {
                gtm.push({
                    event: 'uaEvent',
                    event_name: 'pre_order_submit',
                    button_name: t('btn'),
                    status: 'success',
                });
            } catch (e) {
                console.error(e);
            }
        } else {
            try {
                gtm.push({
                    event: 'uaEvent',
                    event_name: 'pre_order_submit',
                    button_name: t('btn'),
                    status: 'fail',
                });
            } catch (e) {
                console.error(e);
            }
        }
    };

    return (
        <dialog className={`dp3-bundle-dialog-form ${css['dp3-bundle-dialog-form']}`} onClick={handleCloseSelection}>
            <div className="dialog-content">
                <div className="content-header">
                    <p className="header-title">{t('header_title')}</p>
                    <svg className="close" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" onClick={() => callback()}>
                        <path d="M6 5L19 18M19 5L6 18" stroke="black" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                </div>
                <div className="content-body">
                    <p className="title">{t('title')}</p>
                    <div className="form">
                        <div className="input-box">
                            <input
                                type="text"
                                className="name"
                                placeholder={`*${t('name')}`}
                                value={name}
                                onChange={handleNameChange}
                                onFocus={handleNameFocus}
                            />
                            <div className={`suffix ${selectOpen ? 'open' : ''}`} onClick={() => setSelectOpen(!selectOpen)}>
                                <p className="suffix-value">{suffix}</p>
                                <svg className="suffix-svg" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                    <path
                                        d="M2.46143 10.7564L7.79476 5.42306L13.1281 10.7564"
                                        stroke="#000"
                                        strokeWidth="1.4"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                    />
                                </svg>
                                {selectOpen && (
                                    <ul className="selection">
                                        {suffixLists?.map((item: any, k: number) => (
                                            <li className="select" key={k} onClick={() => setSuffix(item?.label)}>
                                                {item?.label}
                                            </li>
                                        ))}
                                    </ul>
                                )}
                            </div>
                        </div>
                        <input
                            type="text"
                            className="email"
                            placeholder={`*${t('email')}`}
                            value={email}
                            onChange={handleEmailChange}
                            onFocus={handleEmailFocus}
                        />
                        {msg && <p className="msg">{msg}</p>}
                        <button className="submit" onClick={handleSubmit}>
                            {t('btn')}
                        </button>
                    </div>
                </div>
            </div>
        </dialog>
    );
}
